module.exports = __webpack_public_path__ + "img/wa_example_card.35f3f2a2.png";